<template>
  <div class="flex flex-wrap -mx-1">
    <div class="p-1" v-for="day in 7" :key="day">
      <vue-checkbox :disabled="disabled" class="no-bullet" v-model="model" :label="day">{{ getName(day) }}</vue-checkbox>
    </div>
  </div>
</template>

<script>
import { formatWeekday } from '../core/helpers';

export default {
  props: {
    value: {},

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    getName(day) {
      return formatWeekday(day, 'ddd');
    },
  },
};
</script>
